import { render } from "./pret-avance.vue?vue&type=template&id=2f12bc2d"
import script from "./pret-avance.vue?vue&type=script&lang=js"
export * from "./pret-avance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__